import React from 'react';
import './App.css';
import Mainview from './modules/mainview';
import { withStyles } from '@material-ui/core/styles'
import { theme } from "./theme";

const GlobalCss = withStyles({
  // @global is handled by jss-plugin-global.
  '@global': {
    '.MuiStepLabel-label': {
      color: theme.colors.light,
    },
    '.MuiStepLabel-label.MuiStepLabel-completed': {
      color: theme.colors.light,
      fontWeight: 500,
    },
  },
})(() => null);

function App() {

  return (
    <div className="App">
      <GlobalCss />
      <Mainview />
    </div>
  );
}

export default App;
